import '../../assets/beautrium-css/footer.scss';
import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { setActiveLanguage, getTranslate, getActiveLanguage } from 'react-localize-redux';
import { version } from '../../assets/constant';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapMarkerAlt } from '@fortawesome/pro-solid-svg-icons';
import { showAuthenticationPopup } from '../../actions/common/index';
import { setLanguagePreference } from '../../actions/profile/index';
import { faFacebookSquare, faInstagram, faLine, faTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';
class Footer extends Component {

    constructor(props) {
        super(props)

        this.state = {
            show1: false,
            show2: false,
            show3: false,
        }
    }

    renderCurrentYear() {
        const currentYear = moment().year();
        if (currentYear > 2017) {
            return `- ${currentYear}`;
        } else {
            return '';
        }
    }

    render() {
        const { translate, authenticated, currentLanguage, setActiveLanguage } = this.props;
        return (
            <footer className="bt-footer">
                <div className="container">
                    <div className="row menu-container">
                        <div className="col-12 text-center find-store">
                            <Link to="/store_locations"><FontAwesomeIcon icon={faMapMarkerAlt} className="mr-1" /> ค้นหาสาขา</Link>
                        </div>
                    </div>
                    <div className="row menu-table-container">
                        <div className="col-md-3 col-12 menu">
                            <div style={{ cursor: 'pointer' }} onClick={this.props.showTrackOrder}>{translate('TRACKING_ORDER')}</div>
                            <div><Link to="/upload_receipt">{translate('CONFIRM_PAYMENT')}</Link></div>
                            <div className="d-none d-md-block language-setting">
                                <span className={`flag ${currentLanguage.code === 'th' ? 'active' : ''}`} onClick={() => { this.props.setLanguagePreference('th'); setActiveLanguage('th') }}><img src={`https://cdn.thebeautrium.com/web-image/thai-flag-small.png`} alt="ภาษาไทย" className="flag-icon" /></span>
                                <span className={`flag ${currentLanguage.code === 'en' ? 'active' : ''}`} onClick={() => { this.props.setLanguagePreference('en'); setActiveLanguage('en') }}><img src={`https://cdn.thebeautrium.com/web-image/uk-flag-small.png`} alt="English Language" className="flag-icon" /></span>
                            </div>
                        </div>
                        <div className="col-md-3 col-12 menu">
                            <div>{translate('FAQ')}</div>
                            <div><Link to="/contactus">{translate('JOIN_PARTNER')}</Link></div>
                        </div>
                        <div className="col-md-3 col-12 menu">
                            <div><Link to="/aboutus">{translate('ABOUT_US')}</Link></div>
                            <div><Link to="/contactus">{translate('CAREER')}</Link></div>
                        </div>
                        <div className="col-md-3 col-12 menu">
                            <div className="follow">
                                <ul className="follow-channels">
                                    <li><a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/beautrium/"><FontAwesomeIcon icon={faFacebookSquare} /></a></li>
                                    <li><a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/theBeautrium/"><FontAwesomeIcon icon={faInstagram} /></a></li>
                                    <li><a target="_blank" rel="noopener noreferrer" href="http://line.me/ti/p/@beautrium"><FontAwesomeIcon icon={faLine} /></a></li>
                                    <li><a target="_blank" rel="noopener noreferrer" href="https://twitter.com/thebeautrium"><FontAwesomeIcon icon={faTwitter} /></a></li>
                                    <li><a target="_blank" rel="noopener noreferrer" href="https://www.tiktok.com/@thebeautrium"><img src={`https://cdn.thebeautrium.com/web-image/icon_tiktok.png`} alt="Tiktok" /></a></li>
                                    <li><a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/channel/UCrtBmEqSg3SOD2wZmrMbElA"><FontAwesomeIcon icon={faYoutube} /></a></li>
                                </ul>
                            </div>
                            {!authenticated ? <div className="text-center subscription"><button className="btn btn-white" type="button" onClick={() => this.props.showAuthenticationPopup(true, 'signup')}>ลงทะเบียนเพื่อรับข่าวสารล่าสุดจากเรา</button></div> : null}
                        </div>
                    </div>
                    <div className="row copyright">
                        <div className="col-12 col-xl-8 copyright-text order-2 order-md-1">2017{this.renderCurrentYear()} © <span className="logo-text">Beautrium</span> Co., Ltd. All Rights Reserved. Beautrium Community Store Version {version}</div>
                        <div className="col-12 col-xl-4 term-privacy order-1 order-md-2">
                            <ul>
                                <li><Link to="/tos">{translate('TERMS_OF_USE')}</Link></li>
                                <li><Link to="/privacy">{translate('PRIVACY_POLICY')}</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </footer>
        )
    }
}

function mapStateToProps(state) {
    return {
        authenticated: state.auth.authenticated,
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale),
    };
}
export default connect(mapStateToProps, { showAuthenticationPopup, setActiveLanguage, setLanguagePreference })(Footer);